const LEAVES = Array.from({ length: 8 }, (_, i) => {
  const a = (i * Math.PI) / 4;
  const p = (dx, dy) => `${(23 + dx * Math.cos(a) - dy * Math.sin(a)).toFixed(1)} ${(23 + dx * Math.sin(a) + dy * Math.cos(a)).toFixed(1)}`;
  return `M${p(0, 0)}Q${p(-8, -11)} ${p(0, -22)}Q${p(8, -11)} ${p(0, 0)}Z`;
}).join(' ');

const Leaf = () => (
  <svg width="46" height="46" viewBox="0 0 46 46" aria-hidden="true">
    <path d={LEAVES} fill="#3f9a44" stroke="#2f7d32" strokeWidth="1" />
    <circle cx="23" cy="23" r="6" fill="#1f5e23" />
  </svg>
);

const Tag = ({ children, className = '' }) => (
  <span className={`rounded-md bg-[#111827]/85 text-white text-[11px] font-bold tracking-wider px-2 py-1 uppercase ${className}`}>{children}</span>
);

const SHAPES = {
  planta: () => <Leaf />,
  bar: (d) => (
    <span className="flex flex-col items-center gap-1">
      <span className="block w-56 h-12 rounded-lg bg-[#4a2f22] shadow-lg" />
      <Tag>{d.name || 'Barra'}</Tag>
    </span>
  ),
  bar_counter: (d) => SHAPES.bar(d),
  banqueta: () => (
    <span className="flex gap-3">{Array.from({ length: 5 }, (_, i) => <span key={i} className="w-6 h-6 rounded-full bg-[#2b1d16] shadow" />)}</span>
  ),
  bathroom: (d) => <span className="block rounded-md bg-[#8b6a4f] text-white text-[11px] font-bold px-4 py-3 shadow">{(d.name || 'Baños').toUpperCase()}</span>,
  door: (d) => <span className="block rounded-t-md bg-[#6b5240] text-white text-[10px] font-bold tracking-widest px-8 py-1">{(d.name || 'Entrada').toUpperCase()}</span>,
  divider: () => <span className="block w-2 h-40 rounded bg-[#2b1d16]" />,
  pared: () => <span className="block w-2 h-40 rounded bg-[#2b1d16]" />,
  ducha: (d) => (
    <span className="flex flex-col items-center gap-1">
      <span className="w-9 h-9 rounded-full bg-[#38bdf8]/80 ring-4 ring-white/70 grid place-items-center text-white font-bold">≋</span>
      <Tag>{d.name || 'Duchas'}</Tag>
    </span>
  ),
  pasarela: (d) => (
    <span className="flex flex-col items-center gap-1">
      <span className="block w-72 h-7 rounded bg-[repeating-linear-gradient(90deg,#a47148_0_16px,#8a5c38_16px_18px)] shadow" />
      <Tag>{d.name || 'Pasarela'}</Tag>
    </span>
  ),
};

export const FloorDecor = ({ item, draggable, onDragStart, onClick, selected }) => {
  const Shape = SHAPES[item.unit_type];
  if (!Shape) return null;
  return (
    <span draggable={draggable} onDragStart={onDragStart} onClick={onClick}
      className={`mfloor-decor absolute -translate-x-1/2 -translate-y-1/2 ${draggable ? 'cursor-move' : 'pointer-events-none'} ${selected ? 'outline outline-2 outline-offset-4 outline-[#2563EB] rounded' : ''}`}
      style={{ left: `${item.position_x ?? 50}%`, top: `${item.position_y ?? 50}%` }} data-testid={`floor-decor-${item.unit_id}`}>
      <Shape {...item} />
    </span>
  );
};

export const ZoneTag = Tag;
